var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card shadow-sm" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("h5", { staticClass: "card-title" }, [
        _vm._v(
          "\n            " +
            _vm._s(
              _vm.$t("pages.subscription.cancel.successfully_canceled_title")
            ) +
            "\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("pages.subscription.cancel.successfully_canceled", {
              date: _vm.$date(_vm.$route.query.expiryDate).format("DD.MM.YYYY")
            })
          )
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mt-5" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-dark mr-3",
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "resume-subscription" })
              }
            }
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("pages.subscription.cancel.changed_my_mind")) +
                "\n            "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "cursor-pointer text-muted",
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "subscription" })
              }
            }
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("pages.subscription.cancel.return")) +
                "\n            "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }